const statusLabels = {
  pending: "PENDENTE",
  approved: "APROVADO",
  rejected: "REPROVADO",
};

const typeLabels = {
  upgrade: "UPGRADE",
  downgrade: "DOWNGRADE",
};

const columnsUpgrades = [
  { key: "created_at", label: "Data da solicitação", align: "center" },
  { key: "type_label", label: "Tipo", align: "center" },
  { key: "before_group", label: "Grupo anterior" },
  { key: "after_group", label: "Novo grupo" },
  { key: "status_label", label: "Situação", align: "center" },
  { key: "requested_by", label: "Solicitante" },
  { key: "approved_by", label: "Decidido por" },
];

export { columnsUpgrades, statusLabels, typeLabels };
